import {
  Icon,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  Text,
} from "@salestrak/ui";
import React from "react";

import { useSidebarNav } from "../use-sidebar-nav";

/** Teams' primary destinations: All Teams and All Members — the standalone
 *  `/teams` and `/members` directory pages. */
export function TeamsNavSection() {
  const { navigate, isActive } = useSidebarNav();

  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            // Exact: a singular team (`/team/[id]`) must not light this row.
            isActive={isActive("/teams", true)}
            onClick={() => navigate("/teams")}
          >
            <Icon name="users" />
            <Text truncate>All Teams</Text>
          </SidebarMenuButton>
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isActive("/members", true)}
            onClick={() => navigate("/members")}
          >
            <Icon name="contact" />
            <Text truncate>All Members</Text>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
